<template>
    <v-sheet class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4" elevation="4" height="250"
        rounded max-width="800" width="100%">
        <div>
            <div class="text-h5 font-weight-medium pa-2">
                DIRECCIÓN GENERAL LOGÍSTICA<br />UNIDAD DE MATERIAL BÉLICO
            </div>
            <p class="text-body-2 mb-4">
                Registro clasificado de armas de fuego, municiones y explosivos de uso
                Militar
            </p>
        </div>
    </v-sheet>
    <v-container fluid>
        <v-card>
            <v-data-table :headers="headers" :items-per-page-options="items_per_page_options" :items="registros"
                :items-per-page-text="$t('$vuetify.dataTable.itemsPerPageText')"
                :no-data-text="$t('$vuetify.dataTable.noDataText')" :hover="true" :loading="loading_data_table"
                :fixed-header="true" :height="500" :multi-sort="true" :show-current-page="true">
            </v-data-table>
        </v-card>
    </v-container>

    <!-- filters -->
</template>

<script>
import DotacionPrincipal from "@/services/DotacionGeneral";
import { defineComponent } from "vue";
import { VDataTable } from "vuetify/labs/VDataTable";

export default defineComponent({
    components: {
        VDataTable,
    },

    data() {
        const loading_data_table = null;
        const registro_original = [];
        const items_per_page_options = [
            { value: 10, title: "10" },
            { value: 25, title: "25" },
            { value: 50, title: "50" },
            { value: 100, title: "100" },
        ];
        const headers = [
            { key: "grado", title: "Grado" },
            { key: "nombre_completo", title: "Nombre Completo"},
            { key: "carnet", title: "Carnet" },
            { key: "nro_pistola", title: "# Pistola" },
            { key: "gestion_dotacion_pistola", title: "Gestión Pistola" },
            { key: "nro_cuchillo", title: "# Cuchillo" },
            { key: "gestion_dotacion_cuchillo", title: "Gestión Cuchillo" },
            { key: "sable_dotacion", title: "Sable" },
            { key: "gestion_sable_dotacion", title: "Gestión Sable" },
            //{ key: "fuerza", title: "Fuerza" },

        ];
        const dotacion_principal = new DotacionPrincipal();
        const registros = [];
        const dialog_date = false;

        return {
            headers,
            dotacion_principal,
            registros,
            loading_data_table,
            registro_original,
            dialog_date,
            items_per_page_options,
        };
    },
    mounted() {
        this.indexDB();
    },
    computed: {

    },

    watch: {
        filterGestionComputed(newDate) {
            if (newDate) {
                this.filterDataGestion();
            }
        },
    },

    methods: {
        async indexDB() {
            this.loading_data_table = "orange";
            try {
                //setTimeout(async () => {
                    const respuesta = await this.dotacion_principal.dotacionprinc();
                    this.loading_data_table = null;
                    this.registros = respuesta;
                    this.registro_original = respuesta;
                    console.log("Registros", this.registro_original);
                //}, 500);
                
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        }
    }, //methods
});
</script>
